import React from 'react';
import { CheckCircle } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function ComparisonSection() {
  const rows = [{
    label: 'Cost',
    agency: '€2,000+',
    diy: '€0-30/mo',
    us: '€249 one-time'
  }, {
    label: 'Speed',
    agency: '4-8 weeks',
    diy: 'Days-weeks',
    us: 'Fast delivery'
  }, {
    label: 'Ownership',
    agency: 'Sometimes',
    diy: 'Yes',
    us: 'Yes — yours'
  }, {
    label: 'Editing',
    agency: 'Pay per change',
    diy: 'You do it',
    us: 'AI-assisted (100/mo)'
  }, {
    label: 'Support',
    agency: 'Variable',
    diy: 'Forums',
    us: 'Direct WhatsApp'
  }, {
    label: 'Conversion Focus',
    agency: 'Rarely',
    diy: 'No',
    us: 'Yes — built-in'
  }];
  return <section id="comparison" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-54">
      <div className="max-w-6xl mx-auto" data-id="element-55">
        <div className="text-center mb-16 reveal" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-57">
            Why This Beats an Agency
          </h2>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-58">
            {['No €2,000+ fees', 'No monthly lock-in', 'Edit anytime with AI', 'Clear process + revisions'].map((item, i) => <div key={i} className="flex items-center space-x-2 bg-white/[0.06] px-4 py-2 rounded-full" data-id="element-59">
                <CheckCircle className="w-4 h-4 text-[#c9a84c]" data-id="element-60" />
                <span className="text-sm text-white/90" data-id="element-61">{item}</span>
              </div>)}
          </div>
        </div>

        <div className="overflow-x-auto reveal" data-id="element-62">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-63">
            <thead data-id="element-64">
              <tr data-id="element-65">
                <th className="p-4 text-white/50 font-medium text-sm uppercase tracking-wider w-1/4" data-id="element-66">
                  Feature
                </th>
                <th className="p-4 text-white/60 font-medium text-lg w-1/4" data-id="element-67">
                  Agencies
                </th>
                <th className="p-4 text-white/60 font-medium text-lg w-1/4" data-id="element-68">
                  DIY Builders
                </th>
                <th className="p-4 text-[#c9a84c] font-bold text-xl w-1/4 rounded-t-xl border-t border-l border-r border-[#c9a84c]/20" style={{
                backgroundColor: 'rgba(201, 168, 76, 0.08)'
              }} data-id="element-69">
                  This Package
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/[0.06]" data-id="element-70">
              {rows.map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-white/[0.02]' : ''} data-id="element-71">
                  <td className="p-4 text-white/80 font-medium" data-id="element-72">{row.label}</td>
                  <td className="p-4 text-white/50" data-id="element-73">{row.agency}</td>
                  <td className="p-4 text-white/50" data-id="element-74">{row.diy}</td>
                  <td className="p-4 text-white font-bold border-l border-r border-[#c9a84c]/20" style={{
                backgroundColor: 'rgba(201, 168, 76, 0.08)'
              }} data-id="element-75">
                    {row.us}
                  </td>
                </tr>)}
              <tr data-id="element-76">
                <td className="p-4" data-id="element-77"></td>
                <td className="p-4" data-id="element-78"></td>
                <td className="p-4" data-id="element-79"></td>
                <td className="p-4 rounded-b-xl border-b border-l border-r border-[#c9a84c]/20" style={{
                backgroundColor: 'rgba(201, 168, 76, 0.08)'
              }} data-id="element-80"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <SectionDivider data-id="element-81" />
    </section>;
}